import script from "./carChangeReviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./carChangeReviewPage.vue?vue&type=script&setup=true&lang=js"

import "./carChangeReviewPage.vue?vue&type=style&index=0&id=4c8f9e8f&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8f9e8f"]])

export default __exports__